import React, { useEffect, useState} from 'react';
import { UserRole } from 'common/models';
import { ApplicationUser } from "@railcrew/design";
import adminService from 'services/adminService';

export const AuthContext = React.createContext<authProps | null>(null);

export interface authProps{
    onLogout: Function,
    setUser: Function,
    setUserRoles: Function,
    userHasPermission: Function,
    isUserInRole: Function,
    user: ApplicationUser,
    roles: UserRole[]
}

function getInitialState() {
    const roles = localStorage.getItem('userRoles')
    return roles ? JSON.parse(roles) : []
  }

const AuthProvider: React.FC<{ onLogout: Function, children: React.ReactNode }> = ({onLogout, children}) => {  
    const [roles, setRoles] = useState<UserRole[]>(getInitialState());
    const [user, setUser] = useState<ApplicationUser>();

    const setUserRoles = () =>{
        adminService.getUserRoles().then((results: UserRole[])=>{
            setRoles(results);
        });
    }


    useEffect(()=>{
        localStorage.setItem('userRoles', JSON.stringify(roles));
    },[roles]);

    const userHasPermission= (permission:string)=>{
        return roles.some(r=> r.permissions.some(p=> p.permissionName === permission));
    }

    function isUserInRole(role) {
          return roles.some(r => r.roleName === role);
      }

    const value = { onLogout, user, setUser, roles, setUserRoles, userHasPermission, isUserInRole};
    return (<AuthContext.Provider value={value}>{children}</AuthContext.Provider>);
};

export default AuthProvider;